import * as React from 'react';
import { Sticky, PricePerLiter, StickyCallToAction, Price } from '@grandvisionhq/common';
import { Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, useCmsData, ProductDetailTitleView, ProductDetailDescriptionView, ProductDetailDisclaimer, ProductDetailPrice, ProductDiscountLabel, Discount, ProductDetailUsps, NonRxProductCTA } from '@grandvisionhq/fun-products';
import { useReviewsContext, Actions, ReviewSnippet } from '@grandvisionhq/reviews';
import { useFeatureToggles } from '@grandvisionhq/state';
import { getLocalizedValue } from '@grandvisionhq/utils';
import { getVariants } from '../../helpers.js';
import { useProductViewHistory } from '../../utils/use-product-view-history.js';
import { ProductImageGalleryContainer } from '../../ProductImageGallery/ProductImageGalleryContainer.js';
import { ProductDetailSpecificationContainer } from '../../ProductDetailSpecification/ProductDetailSpecificationContainer.js';
import { ProductLabelTag } from '../Components/ProductLabelTag/ProductLabelTag.js';
import { VariantPickerContainer } from '../Components/VariantPicker/VariantPickerContainer.js';

const Accessories = ({ activeSku , addToCartRef , brandLink , currency , handleConversionEvent , isMobile , isSmallScreen , isOrderable , labels , locale , onCTAClick , product , stickyTop , stockCount , showStickyButton , variant , variants , storesRoute  })=>{
    const { accessoryColor , brand , channelAvailability , description , discounted , discountText , excludedFromCheckout , header , modelName , price , pricePerLiter , productType , sku , tag , usps ,  } = variant;
    const { Slots  } = useProductDetailSlots();
    const { isProductLabelEnabled , isPricePerLiterEnabled  } = useFeatureToggles();
    const productViewHistory = useProductViewHistory();
    const reviews = useReviewsContext();
    const { usps: productTypeUsps  } = useCmsData();
    // Add SKU to viewed product history
    React.useEffect(()=>{
        // We only want 1 SKU(variant) per product to be in the view history
        productViewHistory.remove(variants.map((v)=>v.sku || ''
        ));
        productViewHistory.add(sku);
    }, [
        variants.length,
        sku
    ]);
    // Make sure the ReviewsDisplay component gets updated with the currently active SKU
    React.useEffect(()=>{
        if (reviews.enabled) {
            reviews.dispatch(Actions.updateReviewDisplay({
                variantId: activeSku
            }));
        }
    }, [
        activeSku,
        reviews.enabled
    ]);
    const CTAButton = /*#__PURE__*/ React.createElement(NonRxProductCTA, {
        storesRoute: storesRoute,
        action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE',
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku,
            onSuccess: onCTAClick
        }
    });
    var _discountedPrice;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main"
    }, isMobile && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${brand} ${modelName}`,
        subtitle: brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: sku,
        variantId: activeSku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, /*#__PURE__*/ React.createElement(ProductImageGalleryContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__description"
    }, /*#__PURE__*/ React.createElement(ProductDetailDescriptionView, {
        header: header,
        description: description,
        usps: usps
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification"
    }, /*#__PURE__*/ React.createElement(ProductDetailSpecificationContainer, null)), /*#__PURE__*/ React.createElement(ProductDetailDisclaimer, {
        className: "product-detail__disclaimer"
    }), /*#__PURE__*/ React.createElement("aside", {
        className: "product-detail__aside",
        "data-t": "product-detail-aside",
        "aria-label": `${brand} ${modelName}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail",
        enabled: !isMobile
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${brand} ${modelName}`,
        subtitle: brand,
        href: brandLink
    })), !isProductLabelEnabled && tag && tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductLabelTag, null)), price && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-prices",
        role: "group",
        "aria-label": labels.priceInformation
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: price.originalPrice,
        discountedPrice: price.discountedPrice,
        currency: currency
    })), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: discountText
    }), !isProductLabelEnabled && discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: discountText,
        discount: discounted,
        isWide: true
    }), isPricePerLiterEnabled && (pricePerLiter === null || pricePerLiter === void 0 ? void 0 : pricePerLiter.amount) && (pricePerLiter === null || pricePerLiter === void 0 ? void 0 : pricePerLiter.currencyCode) && /*#__PURE__*/ React.createElement(PricePerLiter, {
        amount: pricePerLiter.amount,
        currencyCode: pricePerLiter.currencyCode
    })), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null, !isMobile && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: sku,
        variantId: activeSku
    }), /*#__PURE__*/ React.createElement(VariantPickerContainer, {
        variantItems: getVariants(variants, getLocalizedValue(product.slug, locale), productType, locale),
        activeVariantSku: sku,
        activeVariantLabel: accessoryColor,
        enableStockIndicator: !excludedFromCheckout,
        stockCount: stockCount,
        isAllowBackOrder: isOrderable,
        channelAvailability: variant.channelAvailability
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, CTAButton), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), isSmallScreen && showStickyButton && price && /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: CTAButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (_discountedPrice = price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : price.originalPrice,
            currency: currency,
            centAmount: true,
            type: price.discountedPrice ? 'discount' : 'default'
        })
    }), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, null)))));
};
var Accessories$1 = Accessories;

export { Accessories$1 as default };
//# sourceMappingURL=Accessories.js.map
